import { Anchor, Box, Group, Text } from '@mantine/core'
import { LuFlaskConical, LuLogOut } from 'react-icons/lu'
import { useLogout, useSession } from '../../hooks/useAuth'
import classes from './DemoBanner.module.css'

/**
 * Renders nothing for real users. For users with isDemo=true, renders a
 * persistent top banner explaining the session is ephemeral and that data
 * gets wiped nightly. The "Keluar Mode Demo" link signs out and returns
 * the user to the landing page.
 */
export function DemoBanner() {
  const { data } = useSession()
  const logout = useLogout()
  if (!data?.user?.isDemo) return null
  return (
    <Box className={classes.banner} role="status">
      <Group gap="sm" wrap="nowrap" justify="space-between">
        <Group gap={8} wrap="nowrap">
          <LuFlaskConical size={16} />
          <Text size="sm" fw={500}>
            Mode Demo Live · Data otomatis di-reset setiap pukul 03:00 WITA
          </Text>
        </Group>
        <Anchor
          component="button"
          type="button"
          onClick={() => logout.mutate()}
          className={classes.exitLink}
          underline="hover"
        >
          <Group gap={4} wrap="nowrap">
            <LuLogOut size={14} />
            Keluar Mode Demo
          </Group>
        </Anchor>
      </Group>
    </Box>
  )
}
